module.exports = __webpack_public_path__ + "media/images/loghi/lba_logo_po-b2ddb79d8e282efbfdceca93088d6781.png";